import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Step1 from "../step1/Step1";
import Step2 from "pages/step2/Step2";
import Step3 from "pages/step2/step3/Step3";
import Step4 from "pages/step4/Step4";
import Step5 from "pages/step5/step5";
import Step6 from "pages/step6/Step6";
import Step7 from "pages/step7/Step7";
import Step8 from "pages/step8/Step8";
import Step9 from "pages/step9/Step9";
import Step10 from "pages/step10/Step10";
import ChatBot from 'pages/ChatBot/index';

const StepProgressComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  // const dashboard = queryParams.get("dashboard"); // Get dashboard from query parameter

  const [currentStep, setCurrentStep] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  const steps = [
    { label: "Question 1", content: <Step2 /> },
    { label: "Question 2", content: <Step1 /> },
    { label: "Question 3", content: <Step3 /> },
    { label: "Question 4", content: <Step4 /> },
    { label: "Question 5", content: <Step5 /> },
    { label: "Question 6", content: <Step6 /> },
    { label: "Question 7", content: <Step7 /> },
    { label: "Question 8", content: <Step8 /> },
    { label: "Question 9", content: <Step9 /> },
    { label: "Question 10", content: <Step10 /> },
  ];

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const onFormSubmit = () => {
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
      //console.log(dashboard)
      const dashboard = localStorage.getItem('dashboardName'); 
      // console.log(dashboard)
      if(dashboard ==="motor-bikes-for-sale"){
        // console.log("motor-bikes-for-sale")
        navigate("/dashboard/motor-bikes-for-sale");
      }
      if(dashboard==="cables-r-us"){
        // console.log("cables-r-us")
        navigate("/dashboard/cables-r-us")
      }
    }, 3000); // Show popup for 3 seconds
  };

 

  return (
    <div>
      <style>
        {`
          .step-progress-bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
          }

          .step {
            flex: 1;
            padding: 10px;
            text-align: center;
            cursor: pointer;
            border-bottom: 2px solid #ccc;
            color: #ccc;
          }

          .step.active {
            color: #000;
            border-bottom: 2px solid #000;
          }

          .step.completed {
            color: #4CAF50;
            border-bottom: 2px solid #4CAF50;
          }

          .step-content {
            margin-bottom: 20px;
          }

          .navigation-buttons {
            display: flex;
            justify-content: space-evenly !important;
            padding-bottom: 40px !important;
          }

          .thank-you-popup {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(0, 0, 0, 0.8);
            color: white;
            padding: 20px;
            border-radius: 10px;
            text-align: center;
            width: 300px;
            animation: fadeIn 0.5s ease-in-out;
          }

          .navigation-buttons {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          }

          .navigation-buttons button {
            padding: 10px 20px;
            font-size: 16px;
            border: none;
            cursor: pointer;
            border-radius: 5px;
            transition: all 0.3s ease-in-out;
          }

          .navigation-buttons button:disabled {
            background: #ccc;
            cursor: not-allowed;
          }

          // .navigation-buttons button:first-child {
          //   background: #2f80f7;
          //   color: white;
          // }

          // .navigation-buttons button:first-child:hover {
          //   background:rgb(18, 73, 156);
          // }

          // .navigation-buttons button:last-child {
          //   background: #4CAF50;
          //   color: white;
          //   border: 2px solid white;
          // }

          // .navigation-buttons button:last-child:hover {
          //   background: #388E3C;
          // }

          .navigation-buttons button.submit {
            background: #2196F3;
            color: white;
          }

          .navigation-buttons button.submit:hover {
            background: #1976D2;
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: translate(-50%, -60%); }
            to { opacity: 1; transform: translate(-50%, -50%); }
          }
        `}
      </style>

      <div className="step-progress-bar container">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`step ${index === currentStep ? "active" : ""} ${
              index < currentStep ? "completed" : ""
            }`}
            onClick={() => setCurrentStep(index)}
          >
            {step.label}
          </div>
        ))}
      </div>

      <div className="step-content">{steps[currentStep].content}</div>
        <ChatBot />      
        <div className="navigation-buttons">
        <button className="btn btn-primary" onClick={prevStep} disabled={currentStep === 0}>
          Previous
        </button>
        {currentStep < steps.length - 1 ? (
          <div>
             <button className="btn btn-link" onClick={onFormSubmit}>Skip to Dashboard</button>
            <button className="btn btn-primary" onClick={nextStep}>Continue</button>
         
          </div>
        ) : (
          <button onClick={onFormSubmit}>Submit</button>
        )}
      </div>

      {/* {showPopup && (
        <div className="thank-you-popup">
          <div className="popup-content">
            <h2>Thank You!</h2>
            <p>Your submission has been received.</p>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default StepProgressComponent;
